import Tab from '@mui/material/Tab';
import { styled, lighten } from '@mui/material/styles';
// <Tabs/> doesn't need the override but <Tab/> does (here)
// Story with M_TabGroup.tsx
export var Component = styled(Tab)(function (_a) {
    var theme = _a.theme;
    return ({
        textTransform: 'none',
        color: lighten(theme.palette.text.primary, 0.3),
        fontSize: '0.875rem',
    });
});
Component.displayName = 'Tab';
